import React from "react";
import { Collapse } from "antd";
import ApprovalInfoSection from "./ApprovalInfoSection";
import ApprovedBarcode from "./ApprovedBarcode";
import CommentsSection from "./CommentsSection";

const { Panel } = Collapse;

const ApprovalInfo = ({
  documentData,
  activeKeys,
  onChangeCollapse,
  usePanel = true,
}) => {
  const approvalData = documentData?.approval_process_id?.data;

  if (!approvalData) {
    return null;
  }

  const formSetting = approvalData?.form_id?.form_setting?.[0] || null;
  const approvalProcess = formSetting?.approval_process || null;
  const isStrict = !!formSetting?.approval_process_strict;

  const content = (
    <>
      <div
        style={{
          display: "flex",
          gap: 16,
          flexWrap: "wrap",
          alignItems: "flex-start",
          justifyContent: "center",
        }}
      >
        <div style={{ flex: "1 1 320px", minWidth: 260 }}>
          <ApprovalInfoSection
            details={approvalData.detail || []}
            approvalProcess={approvalProcess}
            isStrict={isStrict}
          />
        </div>
        {approvalData.approval_key && (
          <div
            style={{
              flex: "0 0 auto",
              width: "100%",
              maxWidth: 200,
            }}
          >
            <ApprovedBarcode approvalKey={approvalData.approval_key} />
          </div>
        )}
      </div>
      <CommentsSection comments={approvalData.comments} />
    </>
  );

  if (!usePanel) {
    return content;
  }

  return (
    <Collapse
      className="collapse_sr"
      expandIconPosition={"end"}
      bordered={true}
      activeKey={activeKeys}
      onChange={onChangeCollapse}
    >
      <Panel style={{ background: "#fce8b6" }} header={<b>Approval Info & Comments</b>} key="1">
        {content}
      </Panel>
    </Collapse>
  );
};

ApprovalInfo.defaultProps = {
  activeKeys: ['1'],
  onChangeCollapse: () => {},
  usePanel: true,
};

export default ApprovalInfo;
